const allowedAttributes = [ 'fill', 'd' ];

export default {
    allowedAttributes
}